import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    required,
    SelectField,
    ReferenceField,
} from 'react-admin';
import {
    Box,
    Grid
} from '@mui/material';
import { useActiveStatus } from "../../defaults/defaults";

export const AdminEmployeeShow = () => {
    const statuses = useActiveStatus();

    return (
        <Box sx={ { flexGrow: 1, padding: '0 16px 0 16px' } }>
            <Grid container spacing={ 2 }>
                <Grid size={ 12 }>
                    <Show >
                        <Grid container spacing={ 2 }>
                            <Grid size={ 6 }>
                                <SimpleShowLayout>
                                    <TextField source="name" />
                                    <SelectField
                                        source="status"
                                        choices={ statuses }
                                        optionValue="id"
                                    />
                                    <TextField  source="position"  />
                                </SimpleShowLayout>
                            </Grid>
                            <Grid size={ 6 }>
                                <SimpleShowLayout>

                                    <ReferenceField
                                        label="Company"
                                        source="company"
                                        reference="companies"
                                        link="edit"
                                    >
                                        <TextField source="name"/>
                                    </ReferenceField>
                                    <ReferenceField
                                        label="Contact"
                                        source="contact"
                                        reference="people"
                                        link="show"
                                    >
                                        <TextField source="name"/>
                                    </ReferenceField>
                                </SimpleShowLayout>
                            </Grid>
                        </Grid>
                    </Show>
                </Grid>
            </Grid>
        </Box>
    );
}